var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCode = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#EEECF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5361 27.7217C25.3505 27.9175 25.134 28.01 24.8866 27.9991C24.6392 27.9883 24.4227 27.8849 24.2371 27.689C24.0515 27.4932 23.9588 27.2592 23.9588 26.9872C23.9588 26.7152 24.0515 26.4813 24.2371 26.2854L29.7113 20.5077L24.268 14.7627C24.0825 14.5668 23.9948 14.3329 24.0052 14.0609C24.0155 13.7889 24.1134 13.5549 24.299 13.3591C24.4845 13.1632 24.7062 13.0653 24.9639 13.0653C25.2216 13.0653 25.4433 13.1632 25.6289 13.3591L31.7216 19.8222C31.9072 20.0181 32 20.2466 32 20.5077C32 20.7689 31.9072 20.9974 31.7216 21.1932L25.5361 27.7217ZM14.4021 27.6238L8.27835 21.1932C8.09278 20.9974 8 20.7689 8 20.5077C8 20.2466 8.09278 20.0181 8.27835 19.8222L14.4639 13.2938C14.6495 13.0979 14.8711 13 15.1289 13C15.3866 13 15.6082 13.0979 15.7938 13.2938C15.9794 13.4896 16.0722 13.7236 16.0722 13.9956C16.0722 14.2676 15.9794 14.5015 15.7938 14.6974L10.2887 20.5077L15.732 26.2528C15.9175 26.4486 16.0103 26.6771 16.0103 26.9383C16.0103 27.1994 15.9175 27.4279 15.732 27.6238C15.5464 27.8196 15.3247 27.9175 15.067 27.9175C14.8093 27.9175 14.5876 27.8196 14.4021 27.6238Z",
    fill: "#4A3AB1",
    stroke: "#4A3AB1",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCode, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/code.88ecbdc9.svg";
export { ForwardRef as ReactComponent };